import React from 'react';
import { useParams } from 'react-router-dom';

export function ViewPackagingPOEntity() {
    const { purchaseOrderId } = useParams();

    return (
        <div className="flex min-h-screen flex-col">
            <div className="px-4 pt-4">
                <h1 className="text-xl font-semibold">Packaging Purchase Order V2</h1>
                <p className="mt-1 text-sm text-muted-foreground">PO #{purchaseOrderId}</p>
            </div>
            <div className="flex flex-1 flex-col px-4 pb-6 pt-4">
                <div className="rounded-md border border-dashed border-muted-foreground/30 p-6 text-sm text-muted-foreground">
                    Placeholder page for the packaging PO v2 entity view.
                </div>
            </div>
        </div>
    );
}

ViewPackagingPOEntity.displayName = 'ViewPackagingPOEntity';
